(function(){
  var mm = window.matchMedia ? function(q){ return window.matchMedia(q).matches; } : function(){ return false; };
  if (mm('(prefers-reduced-motion: reduce)')) return;
  var fine = mm('(pointer: fine)');
  var small = window.innerWidth < 750;
  function $(s, r){ return (r || document).querySelector(s); }
  function $$(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s){ return s.replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
  var scroller = window;
  function findScroller(el){
    while (el && el !== document.body && el !== document.documentElement){
      var oy = getComputedStyle(el).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight + 1) return el;
      el = el.parentElement;
    }
    return window;
  }
  function sTop(){ return scroller === window ? window.scrollY : scroller.scrollTop; }
  function sMax(){ return scroller === window ? document.documentElement.scrollHeight - window.innerHeight : scroller.scrollHeight - scroller.clientHeight; }
  function flakeSVG(){
    var g = '';
    for (var a = 0; a < 360; a += 60) g += '<g transform="rotate(' + a + ')"><path d="M0 0V-46M0-31l-10-10M0-31l10-10M0-17l-7-7M0-17l7-7"/></g>';
    return '<svg viewBox="-50 -50 100 100" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round">' + g + '<circle r="5"/></svg>';
  }
  /* Snowfall: pre-rendered flake sprites, delta-time motion, adaptive flake count, pauses when hidden. */
  function snow(){
    if ($('.fx-snow')) return;
    var cv = document.createElement('canvas');
    cv.className = 'fx-snow';
    cv.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cv);
    var ctx = cv.getContext('2d', { alpha: true });
    if (!ctx) return;
    var dpr = Math.min(window.devicePixelRatio || 1, small ? 1 : 1.5);
    var W = 0, H = 0, flakes = [];
    var target = small ? 28 : 60;
    var wind = 0, mx = 0.5, lastY = sTop(), vel = 0, running = false, lastT = 0;
    var sprites = [2, 3.2, 4.6].map(function(r){
      var s = document.createElement('canvas');
      var size = Math.ceil(r * 4 * dpr);
      s.width = s.height = size;
      var c = s.getContext('2d');
      var g = c.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size / 2);
      g.addColorStop(0, 'rgba(235,242,252,1)');
      g.addColorStop(0.35, 'rgba(210,222,240,.85)');
      g.addColorStop(1, 'rgba(210,222,240,0)');
      c.fillStyle = g;
      c.fillRect(0, 0, size, size);
      return { img: s, size: size / dpr };
    });
    function size(){
      W = window.innerWidth; H = window.innerHeight;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      cv.style.width = W + 'px'; cv.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function mk(init){
      var z = Math.random();
      var k = z < 0.55 ? 0 : (z < 0.88 ? 1 : 2);
      return { x: Math.random() * W, y: init ? Math.random() * H : -12, k: k, z: 0.35 + z * 0.65, s: 18 + z * 46, ph: Math.random() * 6.28, sw: 8 + Math.random() * 14, o: 0.45 + z * 0.5 };
    }
    size();
    for (var i = 0; i < target; i++) flakes.push(mk(true));
    var rt;
    window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(size, 150); });
    if (fine) window.addEventListener('pointermove', function(e){ mx = e.clientX / W; }, { passive: true });
    var slow = 0, frames = 0;
    function tick(t){
      if (!running) return;
      var dt = Math.min((t - (lastT || t)) / 1000, 0.05);
      lastT = t;
      frames++;
      if (dt > 0.024) slow++;
      if (frames === 90){
        if (slow > 30 && flakes.length > 14) flakes.length = Math.round(flakes.length * 0.6);
        frames = 0; slow = 0;
      }
      var y = sTop(), dy = y - lastY; lastY = y;
      vel += (dy - vel) * 0.15;
      wind += ((mx - 0.5) * 30 - wind) * 0.02;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < flakes.length; i++){
        var f = flakes[i];
        f.ph += dt * (0.8 + f.z);
        f.y += f.s * dt - vel * 0.18 * f.z;
        f.x += (Math.sin(f.ph) * f.sw * 0.15 + wind) * f.z * dt;
        if (f.y > H + 12){ flakes[i] = mk(false); continue; }
        if (f.y < -24){ var n = mk(false); n.y = H + 6; flakes[i] = n; continue; }
        if (f.x > W + 10) f.x = -10; else if (f.x < -10) f.x = W + 10;
        var sp = sprites[f.k];
        ctx.globalAlpha = f.o;
        ctx.drawImage(sp.img, f.x - sp.size / 2, f.y - sp.size / 2, sp.size, sp.size);
      }
      ctx.globalAlpha = 1;
      requestAnimationFrame(tick);
    }
    function start(){ if (running) return; running = true; lastT = 0; requestAnimationFrame(tick); }
    function stop(){ running = false; }
    document.addEventListener('visibilitychange', function(){ if (document.hidden) stop(); else start(); });
    start();
  }
  /* Cursor ring: only animates while the mouse is moving */
  function cursor(){
    if (!fine || $('.fx-cursor')) return;
    var c = document.createElement('div');
    c.className = 'fx-cursor';
    document.body.appendChild(c);
    var x = -100, y = -100, tx = x, ty = y, looping = false;
    function loop(){
      x += (tx - x) * 0.2; y += (ty - y) * 0.2;
      c.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) translate(-50%,-50%)';
      if (Math.abs(tx - x) + Math.abs(ty - y) > 0.4) requestAnimationFrame(loop); else looping = false;
    }
    window.addEventListener('pointermove', function(e){
      tx = e.clientX; ty = e.clientY;
      c.classList.add('is-on');
      var hot = e.target && e.target.closest && e.target.closest('a, button, label, summary, .avs-stage');
      c.classList.toggle('is-hot', !!hot);
      if (!looping){ looping = true; requestAnimationFrame(loop); }
    }, { passive: true });
    document.documentElement.addEventListener('pointerleave', function(){ c.classList.remove('is-on'); });
  }
  function init(root){
    if (root.dataset.fx) return;
    root.dataset.fx = '1';
    root.classList.add('fx-on');
    scroller = findScroller(root.parentElement);
    var bg = document.createElement('div');
    bg.className = 'fx-bg';
    bg.setAttribute('aria-hidden', 'true');
    bg.innerHTML = '<span></span><span></span><span></span><span></span><i class="fx-spot"></i>';
    root.insertBefore(bg, root.firstChild);
    var fin = $('.avs-final', root);
    if (fin){
      var au = document.createElement('div');
      au.className = 'fx-aurora';
      au.setAttribute('aria-hidden', 'true');
      au.innerHTML = '<span></span><span></span><span></span>' + flakeSVG();
      fin.insertBefore(au, fin.firstChild);
    }
    var strip = $('.avs-strip', root);
    if (strip){
      var words = ['Sings Christmas carols', 'Talks back', 'Blinks & winks', 'Glows after dark', 'USB or battery powered', 'The gift of the season'];
      var html = words.map(function(w){ return '<span>' + esc(w) + '<i>❄</i></span>'; }).join('');
      var m = document.createElement('div');
      m.className = 'fx-marquee';
      m.setAttribute('aria-hidden', 'true');
      m.innerHTML = '<div class="fx-marquee-track">' + html + html + '</div>';
      strip.parentNode.insertBefore(m, strip.nextSibling);
    }
    if (!$('.fx-progress')){
      var pb = document.createElement('div');
      pb.className = 'fx-progress';
      document.body.appendChild(pb);
    }
    var progress = $('.fx-progress');
    var t = $('.avs-title', root);
    if (t){
      var label = t.textContent.trim();
      t.setAttribute('aria-label', label);
      t.innerHTML = label.split(/\s+/).map(function(w, i){
        return '<span class="fx-word" aria-hidden="true"><span style="transition-delay:' + (0.15 + i * 0.09).toFixed(2) + 's">' + esc(w) + '</span></span>';
      }).join(' ');
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ t.classList.add('fx-in'); }); });
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('fx-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    function settle(el){
      el.addEventListener('transitionend', function h(ev){
        if (ev.target !== el || ev.propertyName !== 'opacity') return;
        el.removeEventListener('transitionend', h);
        el.classList.remove('fx-r');
        el.classList.add('fx-done');
      });
    }
    var groups = [
      ['.avs-gallery', 0],
      ['.avs-buy > .avs-kicker, .avs-sub, .avs-checks li, .avs-bundle, .avs-form > .avs-atc, .avs-eta, .avs-trust li, .avs-buy .avs-acc details', 0.07],
      ['.avs-strip-item', 0.12], ['.avs-head > *', 0.12], ['.avs-feature > div:last-child > *', 0.1],
      ['.avs-box-item', 0.09], ['.avs-box-note', 0], ['.avs-step', 0.16], ['.avs-compare', 0], ['.avs-compare tbody tr', 0.08],
      ['.avs-faq details', 0.06], ['.avs-final-inner > *', 0.14]
    ];
    groups.forEach(function(g){
      var counts = [];
      $$(g[0], root).forEach(function(el){
        var p = el.parentNode, found = null;
        for (var i = 0; i < counts.length; i++) if (counts[i][0] === p) found = counts[i];
        if (!found){ found = [p, 0]; counts.push(found); }
        el.style.setProperty('--d', Math.min(found[1] * g[1], 0.8).toFixed(2) + 's');
        found[1]++;
        el.classList.add('fx-r');
        settle(el);
        io.observe(el);
      });
    });
    var medias = $$('.avs-feature-media', root);
    medias.forEach(function(el){ el.classList.add('fx-clip'); io.observe(el); });
    var visibleMedia = new Set();
    var mio = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) visibleMedia.add(e.target); else visibleMedia.delete(e.target); });
    });
    medias.forEach(function(m){ mio.observe(m); });
    var stage = $('.avs-stage', root);
    if (stage && fine){
      var tiltRaf = 0, tx = 0.5, ty = 0.5;
      stage.addEventListener('pointermove', function(e){
        var r = stage.getBoundingClientRect();
        tx = (e.clientX - r.left) / r.width; ty = (e.clientY - r.top) / r.height;
        if (tiltRaf) return;
        tiltRaf = requestAnimationFrame(function(){
          tiltRaf = 0;
          stage.classList.add('is-tilting');
          stage.style.transform = 'rotateY(' + ((tx - 0.5) * 10).toFixed(2) + 'deg) rotateX(' + ((0.5 - ty) * 10).toFixed(2) + 'deg) scale(1.02)';
        });
      });
      stage.addEventListener('pointerleave', function(){ stage.classList.remove('is-tilting'); stage.style.transform = ''; });
    }
    if (fine){
      $$('.avs-atc, .avs-btn', root).forEach(function(b){
        b.addEventListener('pointermove', function(e){
          var r = b.getBoundingClientRect();
          var dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2);
          b.style.transform = 'translate(' + (dx * 0.12).toFixed(1) + 'px,' + (dy * 0.3).toFixed(1) + 'px)';
        });
        b.addEventListener('pointerleave', function(){ b.style.transform = ''; });
      });
    }
    function burst(l){
      var n = small ? 8 : 14;
      for (var i = 0; i < n; i++){
        (function(){
          var s = document.createElement('span');
          s.className = 'fx-flake';
          s.textContent = '❄';
          l.appendChild(s);
          var a = Math.random() * Math.PI * 2, d = 40 + Math.random() * 70;
          var anim = s.animate([
            { transform: 'translate(-50%,-50%) scale(.3) rotate(0deg)', opacity: 1 },
            { transform: 'translate(calc(-50% + ' + (Math.cos(a) * d).toFixed(1) + 'px), calc(-50% + ' + (Math.sin(a) * d).toFixed(1) + 'px)) scale(' + (0.7 + Math.random() * 0.8).toFixed(2) + ') rotate(' + Math.round(Math.random() * 360) + 'deg)', opacity: 0 }
          ], { duration: 900 + Math.random() * 500, easing: 'cubic-bezier(.16,1,.3,1)' });
          anim.onfinish = function(){ s.remove(); };
        })();
      }
    }
    $$('.avs-bundle input', root).forEach(function(r){
      r.addEventListener('change', function(){
        burst(r.closest('.avs-bundle'));
        $$('[data-atc-price]', root).forEach(function(p){ p.classList.remove('fx-flip'); void p.offsetWidth; p.classList.add('fx-flip'); });
      });
    });
    var ticking = false;
    function onScroll(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        ticking = false;
        var vh = window.innerHeight, y = sTop(), max = sMax();
        visibleMedia.forEach(function(m){
          var r = m.getBoundingClientRect();
          var c = (r.top + r.height / 2 - vh / 2) / vh;
          m.style.setProperty('--py', (c * -60).toFixed(0) + 'px');
        });
        if (progress) progress.style.transform = 'scaleX(' + (max > 0 ? Math.min(y / max, 1) : 0).toFixed(3) + ')';
      });
    }
    scroller.addEventListener('scroll', onScroll, { passive: true });
    if (scroller !== window) window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
    snow();
    cursor();
  }
  function boot(){ $$('.avs').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();